import { AfterContentInit, Component, Output, EventEmitter } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { ObservableService } from '@app/core/services/observable.service';
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";


@Component({
    selector: 'app-language-picker',
    templateUrl: './language-picker.component.html',
    styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent implements AfterContentInit {

    languages = [
        {code: "ro", name: "Română", flag: "assets/i18n/ro.png"},
        {code: "en", name: "English", flag: "assets/i18n/en.png"},
    ];

    languageKey = 'user-language';
    activeLanguage: any;

    constructor(
        private translationService: TranslateService,
        private observableService: ObservableService
    ) {
    }

    ngAfterContentInit() {
        const savedLanguageCode = localStorage.getItem(this.languageKey) || this.translationService.currentLang || 'en';
        this.activeLanguage = this.languages.find(lang => lang.code === savedLanguageCode) || this.languages[0];
        this.translationService.use(this.activeLanguage.code);
    }

    translate(languageCode: string) {
        const selectedLanguage = this.languages.find(lang => lang.code === languageCode);
        if (selectedLanguage) {
            this.translationService.use(languageCode);
            localStorage.setItem(this.languageKey, languageCode);
            this.activeLanguage = selectedLanguage;
            this.observableService.onChange(); // Notify other parts of the app
        }
    }
}
